const Message = {
  success(message) {
    this.showMessage(message, 'success')
  },
  
  error(message) {
    this.showMessage(message, 'error')
  },
  
  warning(message) {
    this.showMessage(message, 'warning')
  },
  
  info(message) {
    this.showMessage(message, 'info')
  },
  
  showMessage(message, type = 'info') {
    // 创建消息元素
    const messageEl = document.createElement('div')
    messageEl.className = `message message-${type}`
    
    // 根据类型设置样式
    let bgColor = '#409EFF' // 默认info颜色
    let icon = 'ℹ️'
    
    switch(type) {
      case 'success':
        bgColor = '#67C23A'
        icon = '✅'
        break
      case 'error':
        bgColor = '#F56C6C'
        icon = '❌'
        break
      case 'warning':
        bgColor = '#E6A23C'
        icon = '⚠️'
        break
    }
    
    messageEl.style.cssText = `
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      padding: 12px 20px;
      background-color: ${bgColor};
      color: white;
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      z-index: 10000;
      display: flex;
      align-items: center;
      font-size: 14px;
      max-width: 80%;
      animation: messageSlideIn 0.3s ease-out;
    `
    
    messageEl.innerHTML = `
      <span style="margin-right: 8px;">${icon}</span>
      <span>${message}</span>
    `
    
    // 添加动画样式
    if (!document.getElementById('message-style')) {
      const style = document.createElement('style')
      style.id = 'message-style'
      style.textContent = `
        @keyframes messageSlideIn {
          from {
            opacity: 0;
            transform: translateX(-50%) translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }
        }
        
        @keyframes messageSlideOut {
          from {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }
          to {
            opacity: 0;
            transform: translateX(-50%) translateY(-20px);
          }
        }
      `
      document.head.appendChild(style)
    }
    
    // 添加到页面
    document.body.appendChild(messageEl)
    
    // 3秒后自动消失
    setTimeout(() => {
      messageEl.style.animation = 'messageSlideOut 0.3s ease-in'
      setTimeout(() => {
        if (messageEl.parentNode) {
          messageEl.parentNode.removeChild(messageEl)
        }
      }, 300)
    }, 3000)
  }
}

export default {
  install(Vue) {
    Vue.prototype.$message = Message
  }
}